module.exports = __webpack_public_path__ + "img/support-in.3ee7965f.png";